import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";

const ShowDescriptionModal = (props) => {
  return (
    <Dialog
      maxWidth="sm"
      fullWidth="false"
      sx={{ zIndex: 1000 }}
      open={true}
      onClose={props?.handleCloseDialog}
    >
      <DialogTitle
        sx={{ m: 0, p: 1, width: "600px", textAlign: "start", color: "#044A2A" ,display:'flex'}}
      >
            <div style={{ width: "45px", height: "45px", display:'flex' }}>
              <img
                src={props?.dataItem?.vchVendorImage}
                style={{
                  fill:'#FFF',
                  strokeWidth:'1px',
                  stroke:'#FDE1E1',
                  display:'inline-block',
                  position:'relative',
                  overflow:'hidden',
                  borderRadius:"50%",
                  alignSelf: "center",
                  alignItems: "center",
                }}
                alt={"vendor"}
              />
            </div> 
            <Typography
              sx={{
                color: "#044A2A",
                fontWeight: "600",
                fontSize: "18px",
                paddingLeft: "0.5rem",
                paddingRight: "0.5rem",
                alignSelf: "center",
              }}
            >
             {props?.dataItem?.vchVendorName}
            </Typography>
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props?.handleCloseDialog}
        sx={{
          position: "absolute",
          right: 3,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Divider />
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
        <p
          className="show-hide-description justify-content"
          dangerouslySetInnerHTML={{
            __html: props?.dataItem?.vchVendorDescription,
          }}
        ></p>
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default ShowDescriptionModal;
